import React from 'react';
import { AnimatedRippleNumber } from './AnimatedRippleNumber';

interface TotalScoreCardProps {
  totalRipples: number;
}

/**
 * TotalScoreCard - 顯示今日總 Ripples 分數
 *
 * 設計特點：
 * - 大型數字突出顯示總分
 * - 漸層背景和藍色邊框
 * - 使用 AnimatedRippleNumber 提供數字動畫效果
 */
export const TotalScoreCard: React.FC<TotalScoreCardProps> = ({ totalRipples }) => {
  return (
    <div className="bg-gradient-to-br from-sky-50 to-sky-100 border-2 border-sky-200 rounded-2xl p-6 text-center mb-6">
      <div className="text-base font-medium text-gray-600 mb-2">
        Today's Ripples
      </div>
      <AnimatedRippleNumber
        value={totalRipples}
        prefix=""
        className="text-5xl font-bold text-sky-600 mb-1"
      />
      <div className="text-sm text-gray-700">
        ripples earned
      </div>
    </div>
  );
};
